import { useCallback } from "react";
import { useAtom } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useNavigate } from "react-router-dom";

import SideBarItem from "./sideBarItem/main";
import { subSideBarAtom, userAtom } from "../../utils/store";
import styles from "./main.module.css";

import { ReactComponent as DashIcon } from "../../svgs/dash.svg";
import { ReactComponent as OverviewIcon } from "../../svgs/overview.svg";
import { ReactComponent as SettingsIcon } from "../../svgs/settings.svg";
import { ReactComponent as ApprovalIcon } from "../../svgs/approval.svg";
import { ReactComponent as PaymentIcon } from "../../svgs/payment.svg";
import { ReactComponent as ReportIcon } from "../../svgs/reports.svg";
import { ReactComponent as LogoutIcon } from "../../svgs/logout.svg";
import { ReactComponent as CIPMLogo } from "../../svgs/cipm-logo-2.svg";
import { handleLogOut } from "../helpers";
import { ElectoralCommitteeRole, QARole } from "../../utils/allRoles";

interface SideBarProps {
  icon?: React.ReactNode;
  name?: string;
  display?: string;
  className?: any;
}

const sideBarItems1 = [
  // {
  //   icon: <OverviewIcon />,
  //   name: "Overview",
  //   link: "/overview",
  // },
  // {
  //   icon: <SettingsIcon />,
  //   name: "Settings",
  //   link: "/settings",
  // },
  // {
  //   icon: <ApprovalIcon />,
  //   name: "Approvals",
  //   link: "/nominee-approval",
  // },
  // {
  //   icon: <PaymentIcon />,
  //   name: "Payments",
  //   link: "/payments",
  // },
  {
    icon: <ReportIcon />,
    name: "Reports",
    link: "/election-results-report",
  },
];

const sideBarItems2 = [
  {
    icon: <LogoutIcon />,
    name: "Logout",
    link: "/",
  },
];

const sideBarSub = [
  {
    icon: <DashIcon />,
    name: "Election Results Report",
    link: "/election-results-report",
  },
  {
    icon: <DashIcon />,
    name: "Nominee Report",
    link: "/nominee-report",
  },
  {
    icon: <DashIcon />,
    name: "Accreditation Report",
    link: "/accreditation-report",
  },
  {
    icon: <DashIcon />,
    name: "Candidate Report",
    link: "/candidate-report",
  },
  {
    icon: <DashIcon />,
    name: "Voting Report",
    link: "/voting-report",
  },
];




const SideBar: React.FC<SideBarProps> = ({ display, className }) => {
  const resetUser = useResetAtom(userAtom);
  const resetSubSidebar = useResetAtom(subSideBarAtom);
  const [showSideBarItems, setShowSideBarItems] = useAtom(subSideBarAtom);
  const [user] = useAtom(userAtom);
  const userPermissions = user?.Permissions
 
  const lowerCasePermissions = userPermissions?.map(item => item?.toLowerCase())
  const canViewSettings = lowerCasePermissions?.includes('settings')
  const canViewOverview = lowerCasePermissions?.includes('overview')
  const canViewApprovals = lowerCasePermissions?.includes('approvals')
  const canViewReport = lowerCasePermissions?.includes('reports')

  const allRoles = user?.RoleNames;
  // Convert array elements to lowercase
  const lowercaseAllRoles = allRoles?.map((item) => item?.toLowerCase());

  const isQA = lowercaseAllRoles?.includes(QARole?.toLowerCase());
  const isElectoralCommitteeRole = lowercaseAllRoles?.includes(ElectoralCommitteeRole?.toLowerCase());


  const handleShowSubSidebar = useCallback(
    (index: number) => {
      if (index === sideBarItems1.length - 1) {
        setShowSideBarItems(!showSideBarItems);
      } else {
        return;
      }
    },
    [showSideBarItems, setShowSideBarItems]
  );

  // const handleShowSubSidebar2 = useCallback(
  //   (index: number) => {
  //     if (index === QASideBarItems1.length - 1) {
  //       setShowSideBarItems(!showSideBarItems);
  //     } else {
  //       return;
  //     }
  //   },
  //   [showSideBarItems, setShowSideBarItems]
  // );

  return (
    <aside
      className={className}
      style={{
        paddingInline: "12px",
        borderInlineEnd: "1px solid #E5E6E6",
        display: display,
      }}
    >
      <div className={styles.sideBarSub}>
        <div>
          <div className={styles.mainSideBarItem}>
            <CIPMLogo height="4rem" width="4rem" />

            <div>
              <p>CIPM</p>
              <p>E-Voting Portal</p>
            </div>
          </div>

          <div className={styles.mainSideBarItem}>
            <div className={styles.initials}>OO</div>

            <div>
              <p>{user?.FirstName}</p>
              <p>Admin</p>
            </div>
          </div>
          <div>
            {
              canViewOverview &&
              <SideBarItem
                icon={<OverviewIcon />}
                name="Overview"
                link="/overview"
              />
            }
            {
              canViewSettings &&
              <SideBarItem
                icon={<SettingsIcon />}
                name="Settings"
                link="/settings"
              />
            }
            {
              canViewApprovals &&
              <SideBarItem
                icon={<ApprovalIcon />}
                name="Approvals"
                link="/nominee-approval"
              />
            }

          </div>
          {
            canViewReport &&
            <div>
              {sideBarItems1.map((item, index) => (
                <SideBarItem
                  key={index}
                  name={item?.name}
                  icon={item?.icon}
                  link={item?.link} //index === sideBarItems1.length - 1 ? "" :
                  onClick={() => handleShowSubSidebar(index)}
                // isActive={window.location.href.endsWith(item?.link)}
                />
              ))}
            </div>
          }
          <div>
            {showSideBarItems &&
              sideBarSub.map((item, index) => (
                <SideBarItem
                  key={index}
                  name={item?.name}
                  icon={item?.icon}
                  link={item?.link}
                // isActive={window.location.href === item?.link}
                />
              ))}
          </div>
        </div>

        <div>
          {sideBarItems2.map((item, index) => (
            <SideBarItem key={index} name={item?.name} icon={item?.icon} onClick={handleLogOut} />
          ))}
        </div>
      </div>
    </aside>
  );
};

export default SideBar;
